import Page from "webPage/Page";
import $ from "jquery";
import Track from "../../Track";

let history_track;

Page.register('page-template-about-history', () => {

    history_track = new Track($('.js-track-wrap'), {
        classes: {
            block: "timeline",
        },
    });

    $(window).on('resize', () => {
        handleHistorySlider();
    });

    handleHistorySlider();

    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-breadcrumb',
    //     duration: sectionGetHeight('.js-parallax-breadcrumb'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-breadcrumb-circle', 1, {yPercent: -5}, {yPercent: 20}),
    // ])));
});


function handleHistorySlider() {
    if ($(window).outerWidth() > 759) {
        history_track.enable();
    } else {
        history_track.disable();
    }
}

